import { Fragment } from "react";
import "./css/noticias.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Banner from "../../images/home/marca/vision/hyundai-nuestra-vision-futuro.webp";
import BannerSm from "../../images/home/marca/vision/hyundai-nuestra-vision-futuro-sm.webp";
import Reloj from "../../images/assets/icon-clock.png";
import NuevaVision from "../../images/home/marca/vision/hyundai-nueva-vision.webp";
import Arco from "../../images/home/marca/vision/hyundai-nueva-vision-arco.webp";
import Ciudades from "../../images/home/marca/vision/hyunda-nuestra-vision-ciudades.webp";
import CiudadesSm from "../../images/home/marca/vision/hyunda-nuestra-vision-ciudades-sm.webp";
import Scooter from "../../images/home/marca/vision/hyundai-nuestra-vision-scooter.webp";
import Movilidad from "../../images/home/marca/vision/hyundai-nuestra-vision-movilidad.webp";
import Atletas from "../../images/home/marca/vision/hyundai-nuestra-vision-atletas.webp";
import Experiencias from "../../images/home/marca/vision/hyundai-nuestra-vision-experiencias.webp";
import Pasiones from "../../images/home/marca/vision/hyundai-nuestra-vision-pasiones.webp";
import Gol from "../../images/home/marca/vision/hyundai-nuestra-vision-gol.webp";

function InfoVision() {
  return (
    <Fragment>
      <link rel="preload" as="image" href={Banner} />
      <link rel="preload" as="image" href={BannerSm} />
      <link rel="preload" as="image" href={NuevaVision} />
      <link rel="preload" as="image" href={Arco} />
      <link rel="preload" as="image" href={Ciudades} />
      <link rel="preload" as="image" href={CiudadesSm} />
      <link rel="preload" as="image" href={Scooter} />
      <link rel="preload" as="image" href={Movilidad} />
      <link rel="preload" as="image" href={Atletas} />
      <link rel="preload" as="image" href={Experiencias} />
      <link rel="preload" as="image" href={Pasiones} />
      <link rel="preload" as="image" href={Gol} />
      <Container fluid={true}>
        <Row>
          <Col md={12} className="px-0">
            <Image
              src={Banner}
              alt="Hyundai vision"
              className="img1"
              fluid
            />
            <Image
              src={BannerSm}
              alt="Hyundai vision"
              className="w-100 d-block d-sm-none"
              fluid
            />
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col md={12}>
            <span className="home-marca-titulo">MARCA</span>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mt-2 mt-md-0">
            <h1 className="home-titulo">Nuestra visión para el futuro.</h1>
          </Col>
        </Row>
        <Row>
          <Col md={3} className="pr-0">
            <h2 className="home-autor">FOTOS OSLARK ALBAYRAK</h2>
          </Col>
          <Col md={4}>
            <h2 className="home-autor">PALABRAS HYUNDAI MOTORS</h2>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mt-3">
            <Image
              src={Reloj}
              alt="Icono reloj"
              className="home-icono-reloj"
              fluid
            />
            <span className="home-tiempo-lectura ml-2">
              7 minutos de lectura
            </span>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mt-4 mt-md-3">
            <p className="home-texto">
              Hyundai Motor Company se esfuerza por proporcionar libertad de movimiento a todos invirtiendo en servicios de movilidad,
              construyendo una estrecha relación con los principales proveedores de servicios de movilidad y expandiendo nuestro papel más allá del
              sector del transporte automotriz. La compañía desempeñará un papel fundamental en la transición de la sociedad global a la energía
              limpia ayudando a hacer del hidrógeno una fuente de energía económicamente viable.
            </p>
          </Col>
        </Row>
      </Container>
      <Container fluid={true}>
        <Row>
          <Col md={12} className="px-0 mt-4 mt-md-5 pt-md-5">
            <Image src={NuevaVision} width="1589" height="480" alt="Hyundai nueva visión" className="img2" fluid />
          </Col>
        </Row>
      </Container>
      <div className="bg-blue py-4 py-md-5">
        <Container className="py-md-4">
          <Row>
            <Col md={12}>
              <h3 className="home-titulo-franja">
                Nuestra visión <br /> Progreso para la Humanidad.
              </h3>
            </Col>
          </Row>
          <Row>
            <Col md={7} className="pt-4 pt-md-0">
              <span className="home-subtitulo-franja">
                Estamos aquí para hacer lo correcto <br /> por la humanidad.
              </span>
            </Col>
            <Col md={5} className="mt-4 mt-md-0">
              <p className="home-texto-franja">
                La humanidad nos une y nos hace más fuertes.
              </p>
              <p className="home-texto-franja">
                Permitiéndonos fortalecer nuestras relaciones que <br /> se
                sienten conectadas y obtener más de la vida.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="bg-sand py-5 py-md-5">
        <Container className="py-md-4">
          <Row>
            <Col md={12}>
              <h3 className="home-manifiesto-titulo mb-md-4">
                Manifiesto de marca.
              </h3>
              <p className="home-texto-sm">
                Nuestra idea de movilidad futura se basa en el fuerte compromiso que damos a la sociedad. Estamos aquí para hacer lo correcto por la humanidad.
              </p>
              <p className="home-texto-sm">
                Nuestro enfoque en la humanidad significa que entendemos lo que la gente quiere en la vida. Para aprovechar al máximo nuestro tiempo.
              </p>
              <p className="home-texto-sm">
                Entendemos que el tiempo es la mercancía más preciada de todas, la única cosa que el dinero no puede comprar.
              </p>
              <p className="home-texto-sm">
                Así es como la vida no se trata sólo de pasar tiempo, se trata de tiempo bien invertido.
              </p>
              <p className="home-texto-sm">
                Nuestro propósito es reinventar las 24 horas que se nos da igualmente en tiempo de calidad, haciendo que cada momento realmente valga la pena y gratificante.
              </p>
              <p className="home-texto-sm">Esta es nuestra movilidad futura.</p>
              <p className="home-texto-sm">
                No se trata de pasar de la A a la B, sino de los momentos que realmente importan.
              </p>
              <p className="home-texto-sm font-weight-bold mb-0">
                Conectar a las personas con tiempo de calidad.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
      <Container>
        <Row>
          <Col md={12}>
            <Image src={Arco} alt="Hyundai manifiesto" className="img3" fluid />
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mt-3 mt-md-5">
            <h3 className="home-manifiesto-titulo mb-3 mb-md-4">
              Reimaginando el futuro del tiempo. <br /> Cada hora en todas las culturas.
            </h3>
            <p className="home-texto-sm">Horas. Minutos. Segundos.</p>
            <p className="home-texto-sm">
              La vida no se trata de pasar tiempo. <br /> Es tiempo bien invertido.
            </p>
            <p className="home-texto-sm">
              Hyundai está reinventando el tiempo para el futuro. <br /> Un futuro que conecte a las personas con tiempo de calidad. <br /> Es un futuro reinventado para nosotros.
            </p>
            <p className="home-texto-sm">Por tí.</p>
            <h3 className="home-subtitulo py-3 pt-md-5 pb-md-3">
              Cuatro ciudades, cuatro momentos, cuatro pisos.
            </h3>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Image
              src={Ciudades}
              alt="Hyundai ciudades"
              className="img4"
              fluid
            />
            <Image
              src={CiudadesSm}
              alt="Hyundai ciudades"
              className="d-block d-sm-none"
              fluid
            />
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mt-4 mt-md-0">
            <h3 className="home-manifiesto-titulo my-3 my-md-5">
              Reimaginando el futuro del tiempo. <br /> no importa la zona horaria
            </h3>
          </Col>
        </Row>
        <Row>
          <Col md={6} className="order-2 order-md-1">
            <Image src={Scooter} alt="Hyundai Scooter" className="img5" fluid />
          </Col>
          <Col md={6} className="mt-4 mt-md-0 order-1 order-md-2">
            <p className="home-titulo-columna">
              08:45 - Amsterdam <br /> Cuando nada puede detenerte.
            </p>
            <p className="home-texto mt-2">
              Desde coches hasta scooters eléctricas, Hyundai <br /> cree en mejorar nuestra libertad de movilidad <br /> para el futuro.
            </p>
          </Col>
        </Row>
        <Row className="my-2 my-md-5">
          <Col md={6} className="mt-5 mt-md-0">
            <p className="home-titulo-columna">
              13:08 - Seúl <br /> Cuando te levantas a lo imposible.
            </p>
            <p className="home-texto mt-2">
              Hyundai cree que todo el mundo debería tener derecho a moverse, sin importar nuestras limitaciones, en el futuro.
            </p>
          </Col>
          <Col md={6} className="text-right my-5 my-md-0">
            <Image src={Movilidad} alt="Hyundai movilidad" className="img6" fluid />
          </Col>
        </Row>
        <Row>
          <Col md={12} className="py-2 py-md-3">
            <Image src={Atletas} alt="Hyundai atletas" className="img7" fluid />
          </Col>
        </Row>
        <Row className="mt-5 pt-2 py-md-5">
          <Col md={7} className="order-4 order-md-3">
            <Image src={Experiencias} alt="Hyundai experiencias" className="img5" fluid />
          </Col>
          <Col md={5} className="order-3 order-md-4">
            <p className="home-titulo-columna">
              7:40 - Los Angeles <br /> Cuando puedes saltar en las cosas <br /> que amas.
            </p>
            <p className="home-texto mt-2">
              Con mejores innovaciones de conectividad, Hyundai cree que los vehículos pueden proporcionar experiencias más personalizadas para las personas en el futuro.
            </p>
          </Col>
        </Row>
        <Row className="my-2 my-md-5">
          <Col md={4} className="mt-5 mt-md-0">
            <p className="home-titulo-columna">
              21:58 - Chongqing <br /> Cuando nunca te rindes <br />a tus pasiones.
            </p>
            <p className="home-texto mt-2">
              Hyundai cree que todo el mundo debería tener derecho a moverse, sin importar nuestras limitaciones, en el futuro.
            </p>
          </Col>
          <Col md={8} className="text-right">
            <Image src={Pasiones} alt="Hyundai pasiones" className="img5" fluid />
          </Col>
        </Row>
      </Container>
      <Container fluid={true}>
        <Row>
          <Col md={12} className="px-0 mt-5 mt-md-4">
            <Image src={Gol} width="1589" height="480" alt="Hyundai pasiones" fluid className="img2" />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}
export default InfoVision;